import { useSearch } from '@faststore/sdk'
import type { SearchSort } from '@faststore/sdk/dist/types'
import type { IStoreSelectedFacet } from '@generated/graphql'
import type { FC } from 'react'
import React, { useContext, createContext, useState } from 'react'

interface IFilterContextProps {
  selectedFacets: IStoreSelectedFacet[]
  setSelectedFacets: React.Dispatch<React.SetStateAction<IStoreSelectedFacet[]>>
  sort: SearchSort
  setSort: React.Dispatch<React.SetStateAction<SearchSort>>
}

const FilterContext = createContext<IFilterContextProps>(
  {} as IFilterContextProps
)

export const FilterContextProvider: FC<React.PropsWithChildren> = ({
  children,
}) => {
  const {
    state: { selectedFacets: selectedFacetsSearch, sort: sortSearch },
  } = useSearch()

  const [sort, setSort] = useState(sortSearch)
  const [selectedFacets, setSelectedFacets] =
    useState<IStoreSelectedFacet[]>(selectedFacetsSearch)

  return (
    <FilterContext.Provider
      value={{
        selectedFacets,
        setSelectedFacets,
        sort,
        setSort,
      }}
    >
      {children}
    </FilterContext.Provider>
  )
}

export const useFilterContext = () => {
  return useContext(FilterContext)
}
